import { createSlice } from '@reduxjs/toolkit';
import { GetActiveCategoriesForCaseQuery } from 'src/graphql/generated';

export type ActiveCategories =
  GetActiveCategoriesForCaseQuery['getActiveCategoriesForCase'];

export type CategoriesInitialState = {
  activeCategories: ActiveCategories;
};

const initialState: CategoriesInitialState = {
  activeCategories: null,
};

export const categoriesSlice = createSlice({
  name: 'categories',
  initialState,

  reducers: {
    activeCategoriesUpdated: (
      state,
      action: { payload: ActiveCategories | null },
    ) => {
      if (!action.payload?.length) {
        return state;
      }

      state.activeCategories = action.payload;
    },
  },

  selectors: {
    getActiveCategories: (state: CategoriesInitialState) =>
      state.activeCategories,
  },
});

export const { activeCategoriesUpdated } = categoriesSlice.actions;
export const { getActiveCategories } = categoriesSlice.selectors;

export const categoriesReducer = categoriesSlice.reducer;
